import { TAttributeConstriants } from "./types"

export const DEFAULT_ATTRIBUTE_CONSTRAINT_VALUE = {
    allowed_chars: "",
    allowed_user_defined_values: false,
    attr_inheritance: false,
    child_attr: "",
    column_order: 0,
    datatype: "TEXT",
    extra_criteria_value1: "",
    extra_criteria_value2: "",
    multiselect: false,
    multiselect_number: null,
    multiselect_output_range: "",
    prohibited_chars: "",
    special_formatting: "",
    validation: false,
    validation_error_alert: false,
    validation_error_alert_body: "",
    validation_error_alert_style: "",
    validation_error_alert_title: "",
    validation_input_message: false,
    validation_input_message_body: "",
    validation_input_message_title: "",
    validation_range: "",
    validation_type: "LOV",
    validation_type_extra_criteria: "",
}

export const generateAttributeConstraintObject = (constraints: TAttributeConstriants) => {
    return {
      ...DEFAULT_ATTRIBUTE_CONSTRAINT_VALUE,
      ...Object.fromEntries(Object.entries(constraints)
        .filter(([key, value]) => value!==null)
      )
    }
  }
